export enum EmployeesTableColumnKeys {
	CoworkerName = 'coworkerName',
	CoworkerEmail = 'coworkerEmail',
	CoworkerDataSources = 'coworkerDataSources',
	AccountStatus = 'accountStatus',
	OrganizationPath = 'organizationPath',
	RoleTitle = 'roleTitle',
	ChangeDate = 'changeDate',
	AutoDiscovery = 'autoDiscovery'
}